<template>
  <div id="services">
    <div id="rows" class="d-flex flex-column justify-content-around align-items-center">
      <row class="rowa" v-for="(service, index) in filteredServices.lg1" :key="index" :servicesLg1='service' :servicesLg2='filteredServices.lg2[index]'></row>
    </div>
    <div id="additionalServices" v-if="additionalServices" class="d-flex flex-column align-items-left">
      <div class="lg1" v-html="additionalServices.lg1.label_value"></div>
      <div class="lg2" v-html="additionalServices.lg2.label_value"></div>
    </div>
    <legalNoticeCenter :legalNoticeLg="legalNoticeLg"></legalNoticeCenter>
  </div>
</template>

<script>
  import Row from './rowServices'
  import LegalNoticeCenter from './legalNoticeCenter'

  export default {
    name: 'NovotelRatesHorizontalV1Services',
    props: {
      servicesLg: Object
    },
    components: {
      row: Row,
      'legalNoticeCenter': LegalNoticeCenter
    },
    computed: {
      filteredServices: function () { // remove additional services if necessary
        if (this.servicesLg.lg1.settings.additional_services === '1') {
          return { lg1: this.servicesLg.lg1.otherServices.regular.slice(0, -1), lg2: this.servicesLg.lg2.otherServices.regular.slice(0, -1) }
        } else {
          return { lg1: this.servicesLg.lg1.otherServices.regular, lg2: this.servicesLg.lg2.otherServices.regular }
        }
      },
      additionalServices: function () {
        if (this.servicesLg.lg1.settings.additional_services === '1') {
          let regularLg1 = this.servicesLg.lg1.otherServices.regular
          let regularLg2 = this.servicesLg.lg2.otherServices.regular
          return { lg1: regularLg1[regularLg1.length - 1], lg2: regularLg2[regularLg2.length - 1] }
        } else {
          return null
        }
      },
      legalNoticeLg () {
        if (this.servicesLg) {
          return {lg1: this.servicesLg.lg1.subtitles['2'], lg2: this.servicesLg.lg2.subtitles['2']}
        } else {
          return null
        }
      }
    }
  }
</script>

<style lang="scss">
$srcWidth: 1920;
$srcHeight: 1200;
@import "../../../../_novotel.scss";

#novotelRatesHorizontalV1 #services {
  margin-top: 92 * 100vh / $srcHeight;
  #rows {
    width: 100%;

    .rowa:nth-of-type(n+6){
      display:none!important;
    }
  }

  #additionalServices {
    @include heightPercent(120);
    border-image-source: url(../assets/novotel_Séparation_904x9px.png);
    border-image-slice: 9 0 9 0 fill;
    border-image-width: 9px 0px 9px 0px;
    border-image-repeat: repeat repeat;

    .lg1, .lg2 {
      p {
        font-family: "Novotype-Medium";
        text-transform: uppercase;
        margin-bottom: 0px;
        line-height: 1.2rem;
        display: inline-block;
        @include fontSize(35);

        &:first-letter {
          text-transform: uppercase;
        }
      }
      p:nth-of-type(2) {
        text-transform: initial;
        font-family: "National-Medium";
        @include fontSize(30);
        &:before {
          content : ': ';
        }
      }
    }

    .lg1 {
      margin-top: 0.9vh;
      @include fontSize(35);
    }

    .lg2 {
      @include fontSize(29);

      p:nth-of-type(1) {
        font-family: "Novotype-Regular";
      }

      p:nth-of-type(2) {
        font-family: "National-Medium";
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/novotel/rates/horizontal/v1/services/services.vue